const NAMESPACE = "enableMfADialog";

const KEYS = {
    enableMfaDialogTitle: "enableMfaDialogTitle",
    enableMfaDialogMessage: "enableMfaDialogMessage",
    enableMfaDialogCloseBtnLabel: "enableMfaDialogCloseBtnLabel",
    enableMfaDialogGoToMyAccountBtnLabel: "enableMfaDialogGoToMyAccountBtnLabel"
};

const MESSAGES = {
    [KEYS.enableMfaDialogTitle]: {
        value: "Enable Multi-Factor Authentication",
        comment: "Enable multi-factor authentication dialog title"
    },
    [KEYS.enableMfaDialogMessage]: {
        value: "Because CPR Admin accounts have broad access to all customer programs, it is required for CPR\
            Admin accounts in production to enable Multi-factor Authentication (MfA). Please enable MfA for\
            your account on the My Account page as soon as possible. If you do not currently require CPR\
            Admin privileges, contact pcprod{'@'}cleanpower.com to have your privileges reduced."
    },
    [KEYS.enableMfaDialogCloseBtnLabel]: {
        value: "Close",
        comment: "Enable multi-factor authentication dialog close button label"
    },
    [KEYS.enableMfaDialogGoToMyAccountBtnLabel]: {
        value: "Go to my account",
        comment: "Enable multi-factor authentication dialog go to my account button label"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
